import { render, staticRenderFns } from "./UpdatePromotionBundle.vue?vue&type=template&id=fea24450"
import script from "./UpdatePromotionBundle.vue?vue&type=script&lang=js"
export * from "./UpdatePromotionBundle.vue?vue&type=script&lang=js"
import style0 from "./UpdatePromotionBundle.vue?vue&type=style&index=0&id=fea24450&prod&lang=css"
import style1 from "./UpdatePromotionBundle.vue?vue&type=style&index=1&id=fea24450&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports